import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import services from "../services";

interface PostState {
  data: any[];
  loading: boolean;
  error: boolean;
  errorCode?: string;
}

const initialState: PostState = {
  data: [],
  loading: false,
  error: false,
  errorCode: undefined,
};

const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {
    getPost: (state) => {
      state.loading = true;
      state.error = false;
      state.errorCode = undefined;
      state.data = [];
    },
    getPostSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.error = false;
      state.data = action.payload;
    },
    getPostFailure: (state, action: PayloadAction<string | undefined>) => {
      state.loading = false;
      state.error = true;
      state.errorCode = action.payload;
      state.data = [];
    },
  },
});

export const { getPost, getPostSuccess, getPostFailure } = postSlice.actions;

export const fetchPost = (formData: FormData) => async (dispatch: any) => {
  dispatch(getPost());
  try {
    await services.doPost(formData);
    dispatch(getPostSuccess({ response: "Agendamento efetuado com sucesso" }));
    window.location.reload();
  } catch (err: any) {
    console.log("err: ", err);
    dispatch(getPostFailure(err?.response?.data?.code));
  }
};

export const updatePost = (formData: any) => async (dispatch: any) => {
  dispatch(getPost());
  try {
    await services.updatePost(formData);
    dispatch(getPostSuccess({ response: "Revogado com sucesso" }));
    window.location.reload();
  } catch (err) {
    console.log("err: ", err);
    dispatch(getPostFailure());
  }
};

export default postSlice.reducer;
